import React, { useState } from "react";
import { Typography, Box, Button, Container } from "@material-ui/core";
import AdaptiveModal from "Components/modal/Modal/AdaptiveModal";
import ExecutiveSnapshotImg from "Assets/images/ExecutiveSnapshot.png";
import EmptyStateImg from "Assets/images/empty-state/report-placeholder.svg";
import useStyles from "./styles";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";

const ExecutiveSnapshot = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false)
  }
  return (
    <Container maxWidth="lg">
      {/* <PageHeader title={"Executive snapshot"} containerWidth="lg" /> */}
      <Box mt={3}>
        <Box className={classes.placeholderContent} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
          <img src={EmptyStateImg} alt="placeholder" className={classes.placeholderImg} />
          <Typography variant="subtitle1" className="font-20">Coming Soon!</Typography>
          <Typography variant="body2" className={classes.paraContent}>
            We will notify you once this feature is ready
          </Typography>
          <Button
            className="custom-btn"
            onClick={() => {
              setOpen(true);
            }}>
            Preview sample report
          </Button>
          <AdaptiveModal
            open={open}
            setOpen={handleClose}
            handleClose={handleClose}
            size="md"
            title={"Sample template"}
            body={
              <div>
                <img src={ExecutiveSnapshotImg} width="100%" />
                <Box
                  className={classes.previewIndicator}
                  display="flex"
                  alignItems="center"
                  p={3}>
                  <VisibilityOutlinedIcon />
                  Preview
                </Box>
              </div>
            }
            showCancel={false}
            showOk={false}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default ExecutiveSnapshot;
